module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-518.1485895.woff2";